import { useSharedTranslation } from "#hooks/useSharedTranslation.ts";
import { Div, type DivProps, Flex, Text } from "@hopper-ui/components";
import { AttachmentIcon } from "@hopper-ui/icons";
import "./FileDropZone.css";
import "./FileDropZone.dark.css";

export const FileDropZone = (props: DivProps) => {
    const { tShared } = useSharedTranslation();

    return (
        <Div
            position="fixed"
            top={0}
            left={0}
            zIndex={10}
            width="100%"
            height="100%"
            {...props}
        >
            <Flex
                alignItems="center"
                justifyContent="center"
                width="100%"
                height="100%"
                className="wai-file-drop-zone"
            >
                <Flex
                    direction="column"
                    color="core_orchid-bloom-600"
                    gap="inline-sm"
                    alignItems="center"
                >
                    <AttachmentIcon fill="currentcolor" size="lg" className="wai-file-drop-zone-icon" />
                    <Text size="md" className="wai-file-drop-zone-text">{tShared("dragAndDropFile")}</Text>
                </Flex>
            </Flex>
        </Div>
    );
};
